<template>
  <div class="login">
    <div
      style="
        height: 50px;
        text-align: right;
        padding-right: 210px;
        padding-top: 15px;
        font-size: 1rem;
        color: black;
      "
    >
      <label>語言/Language：</label>
      <select
        class="language"
        name="language"
        v-model="langSelected"
        @change="getLanguage"
      >
        <option
          :value="langItem.id"
          v-for="langItem in language"
          :key="langItem.id"
        >
          {{ langItem.name }}
        </option>
      </select>
    </div>
    <h2 class="title" style="text-shadow: 2px 2px 4px #fff">
      {{ $t("app.appName") }}
    </h2>
    <div class="form">
      <div v-if="type === true">
        <button class="btn" @click="login">{{ $t("app.login") }}</button>
      </div>
      <div v-else>
        <div style="width: 100%; padding: 5px 0; position: relative">
          <span class="span_50" style="font-weight: 900">
            <input type="radio" id="new" value="new" v-model="studentType" />
            {{ $t("app.loginView.newStudent") }}
          </span>
          <span class="span_50" style="font-weight: 900">
            <input type="radio" id="old" value="old" v-model="studentType" />
            {{ $t("app.loginView.oldStudent") }}
          </span>
        </div>
        <input
          v-if="studentType === 'new'"
          type="text"
          v-model="username"
          :placeholder="$t('app.applicationNumber')"
        />
        <input
          v-if="studentType === 'new'"
          type="text"
          v-model="password"
          :placeholder="$t('app.certificateNumber')"
        />
        <el-button
          style="margin-top: 30px"
          class="btn"
          @click="login"
          :disabled="studentType === 'new' && (!username || !password)"
          :loading="loading"
        >
          {{ $t("app.login") }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { login } from "@/api/login";
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      username: "",
      password: "",
      langSelected: localStorage.getItem("lang") || "zh-TW",
      type: true,
      studentType: "admin",
      isUat: JSON.parse(localStorage.getItem("$myconfig")).isUat
    };
  },
  components: {},
  methods: {
    isPhone() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      this.isMobile = flag === null;
      this.$store.commit("Config/set_device", this.isMobile);
      return flag;
    },
    login() {
      this.$store.commit("Config/set_studentType", "admin");
      this.$router.push({
        path: "/backstage"
      });
    },
    getLanguage() {
      this.$i18n.locale = this.langSelected;
      localStorage.setItem("lang", this.langSelected);
    }
  },
  mounted() {
    this.isPhone();
  },
  watch: {},
  computed: {
    language() {
      return [
        {
          id: "zh-TW",
          name: this.$t("app.zhTW")
        },
        {
          id: "en",
          name: this.$t("app.en")
        }
      ];
    }
  }
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  background: url("../../assets/login/login.jpg") center no-repeat;
  background-size: 100% 100%;
  .title {
    position: absolute;
    top: 25%;
    width: 100%;
    font-family: "Arial Negreta", Arial, Helvetica, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 32px;
    text-align: center;
    letter-spacing: normal;
    color: rgb(51, 51, 51);
  }
  .language {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 200px;
    height: 30px;
    line-height: 25px;
    outline: none;
    font-size: 14px;
    border-radius: 5px;
  }
  .form {
    position: absolute;
    width: 350px;
    top: 25%;
    left: 50%;
    margin-top: 90px;
    margin-left: -175px;
    padding: 16px;
    border-radius: 8px;
    background-color: rgba($color: #fff, $alpha: 0.6);
  }
  .btn {
    width: 100%;
    border-width: 0px;
    height: 40px;
    background-color: rgba(22, 155, 213, 1);
    border: none;
    border-radius: 5px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: "Arial Normal", Arial, Helvetica, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    color: #fff;
    vertical-align: none;
    text-align: center;
    line-height: normal;
    text-transform: none;
  }
  .type-btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 150px;
  }
  .span_50 {
    font-family: "Arial Normal", "Arial", Arial, Helvetica, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    letter-spacing: normal;
    color: #333333;
    input[type="radio"] {
      transform: translateY(2px);
    }
    &:nth-of-type(even) {
      position: absolute;
      right: 0;
    }
  }
  input[type="text"],
  input[type="password"] {
    box-sizing: border-box;
    width: 100%;
    height: 30px;
    line-height: 100%;
    text-indent: 3px;
    margin-top: 13px;
    border: none;
    padding: 3px;
    border-radius: 5px;
  }
}
</style>
